import { SET_ACTIVATEPRODUCT } from '../actions';

const productactive = (state = [], action) => {
  switch (action.type) {
	case SET_ACTIVATEPRODUCT:
      return [...action.value];  
    default: return state;
  }
}

export default productactive;
